export const ROUTES = {
  home: "/sales-enablement/print-options",
  create: "/sales-enablement/print-options/new",
  edit: (id: string) => `/sales-enablement/print-options/${id}`,
};

export const QUERY_KEYS = {
  printOptions: "printOptions",
};
